<template>
    <div :class="!isMenuFull?'frame-padding':'main__menu-active'">
            <div v-if="!isMenuFull" class="header__menu">
                <button @click="menuFull"></button>
                <menu >
                    <li v-for="item in mainMenu" :key="item.id">
                        <router-link :to="''+item.link" :class="$route.path=='/'+item.link?'active':''" >
                            {{item.label}}
                        </router-link>
                    </li>
                </menu>
            </div>
        <div class="main__menu" v-else>
            <div class="main__menu__header_mini">
                <div class="logo">
                    <img src="/img/logo.d0606a66.svg" alt="">
                </div>
                <button @click="menuFull"></button>
            </div>
            <menu ref="menu">
              
                <li v-for="item in  fullMenu" :key="item.id" :class="activeMenuItem == item.id?'mini__cascader_active':''">
                    <h3 v-if="item.id_parent == null">
                        <router-link :to="''+item.link" :class="$route.path=='/'+item.link?'active':''" @click="menuFull">
                            {{item.label}} 
                        </router-link>
                        <button v-if="item.children != undefined" class="mini__cascader" @click="item.children != undefined?activeMenu(item.id):''"></button>
                    </h3> 
                    <template  v-for="value in item.children"  :key="value.id">
                        <router-link :to="''+value.link" :class="$route.path=='/'+value.link?'active':''" @click="menuFull" >
                            {{value.label}}
                        </router-link>
                        <router-link v-for="value1 in value.children"  :key="value1.id" :to="''+value1.link" :class="$route.path=='/'+value1.link?'active':''" @click="menuFull">
                            <span>
                                {{value1.label}}
                            </span>
                        </router-link>
                    </template>
                </li>
                <div class="last">
                    <button @click="menuFull"></button>
                </div>
            </menu>
            <button-ms @click="$emit('showRecord',showRecord = !showRecord)">Записаться на прием</button-ms>
        </div>
    </div>
</template>
<script>
import { nextTick } from 'vue';
import buttonMs from '../common/buttonMs.vue';
export default{
    components:{
        buttonMs
    },
    watch:{
        items: {
            handler(items) {
                this.mainMenu = items.filter(e=>{return e.main == 1}).sort((a,b)=>{
                    if ( a.sort_main < b.sort_main) {
                        return -1;
                    }
                    if (a.sort_main > b.sort_main) {
                        return 1;
                    }
                    return 0;
                })
                this.fullMenu = items.sort(this.sortMenu)
            },
            deep: true
        },
        isMenuFull:{
            handler() {
                nextTick(()=>{
                    if (this.$refs.menu != null && this.$refs.menu.clientWidth<1000){
                        this.$emit('active',true)
                    }else {
                        this.$emit('active',false)
                    }
                    if (this.$refs.menu != null && this.$refs.menu.clientWidth>1000){
                        let height = 0 
                    
                        while (this.$refs.menu.scrollWidth > this.$refs.menu.clientWidth){
                            this.$refs.menu.style.height = 'calc(100% - 144px + '+height+'px)';
                            height+=40
                        }
                    }
                })
                
            },
            immediate: true
        },
    },
    props:{
        items:{type:Array}
    },
    methods:{
        activeMenu(id){
            this.activeMenuItem = id 
        },
        sortMenu(a,b){
            if (+a.sort_all > +b.sort_all && a.sort_all != null && b.sort_all != null)
                return 1 
            if(+a.sort_all < +b.sort_all && a.sort_all != null  && b.sort_all != null){
                return -1
            }
            return 0 
        },
        menuFull(){
            this.isMenuFull = !this.isMenuFull
          

            if (this.isMenuFull) {
                document.body.style.overflow = 'hidden'
            }
            if (!this.isMenuFull) {
                document.body.style.overflow = 'auto'
            }
        },
    },
    data(){
        return {
            mainMenu:this.items.filter(e=>{return e.main == 1}),
            fullMenu:[],
            isMenuFull:false,
            activeMenuItem:false,
            showRecord:false
        }
    }
}
</script>
<style>
    .header__menu{
        display: flex;
        align-items: center;
    }
    .header__menu>button{
        display: block;
        width: 29px;
        height: 22px;
        margin: 9px 5px;
        padding: 0;
        background: transparent;
        border:none;
        cursor:pointer;
    
    }
    .header__menu>button::after{
        content: '';
        display: block;
        height: 4px;
        width: 100%;
        background-color:#175472 ;
        border-radius: 10px;
        margin-top: 5px;
        box-shadow: 0px 9px #175472;
    }
    .header__menu>button::before{
        content: '';
        display: block;
        height: 4px;
        width: 100%;
        background-color:#175472 ;
        border-radius: 10px;
        margin-top: -8px;
    }

    .header__menu menu{
        margin: 0;
        display: flex;
        margin-left:46px;
    }
    .header__menu menu{
        list-style: none;
        padding: 0;
    }
    .header__menu menu a{
        padding: 17px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 176px;
        font-size: 16px;
        text-decoration: none;
        color:#175472;
        font-weight: 501;
        line-height: 130%;
        border-bottom: solid 2px transparent;
        height: 100%;
        box-sizing: border-box;
    }
    .header__menu menu a:hover,
    .header__menu menu a:focus{
        color:#007BB8;
        
    }
    .header__menu menu a.active{
        border-bottom: solid 3px #DE4B1B;
    }

    .main__menu{
        height: calc(100vh - 128px);
        width: 100%;
        position: relative;
        min-height:655px ;
        overflow: auto;
    }
    .main__menu button{
        border-radius: 5px ;
        color: #fff;
        background-color: #0D3041;
        height: 42px;
        width: 42px;
        border: none;
        position: relative;
        cursor: pointer;
        /* right: -60px; */
    }
    .main__menu button::after,
    .main__menu button::before{
        position: absolute;
        content: '';
        width: 17px;
        height: 2px;
        top: 20px;
        left: 13px;
        transform: rotate(45deg);
        background-color: var(--white);
        border-radius: 1px;
    }       
    .main__menu button::before{
        transform: rotate(-45deg);
    }
    .main__menu menu{
        margin: 0;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: calc(100% - 144px);
        padding: 35px 0 0;
        gap:35px;
        position: relative;
        max-width: 1385px;
        left: 50%;
        transform: translate(-50%);
        min-height:655px ;
        

    }
    .main__menu menu li{
        list-style: none;
        width: 300px;
        display: flex;
        flex-direction: column;
        gap:10px;
    }

    .main__menu menu a{
        text-decoration: none;
        color:#174E72;
        line-height: 130%;
        /* margin-bottom: 16px; */
    }
    .main__menu menu a:hover{
        color:#007BB8;
    }
    .main__menu menu h3 a{
        line-height: 130%;
        font-size: 16px;
        color:#0D3041 ;

    }
    .main__menu menu h3{
        margin: 0;
        margin-bottom: 24px;
    }
    .main__menu menu h3:last-child{
        margin: 0;
    }
    .main__menu menu a span{
        margin-left: 32px;
        display: block;
    }
    .main__menu .last{
        height: calc(100vh - 300px);
    }
    .main__menu  .main__menu__header_mini,
    .main__menu  .main__menu__header{
        display: none;          
    }
    .mini__cascader{
        display: none;
    }
    .main__menu .search-ms__button{
        display: none;
    }
@media (max-width: 1350px){
    .header__menu menu{
        margin-left:20px;
    }
    .header__menu menu a{
        width: 163px;
    }   
}
@media (max-width: 1220px){
    .header .head__top a,
    .header .head__top button{
       display: none;
    } 
    .header .head__top{
        display: flex;
        justify-content: center;    
    }
    .header__menu menu{
        margin-left:10px;;
    }
    .header__menu menu a{
        width: 136px;
    }   
      
}
@media (max-width: 1000px){
    .main__menu{
        overflow: hidden;
        background-color: #EDF6FF;
        height:100vh;
    }
    .header__menu menu{
        display: none;
    }
    .main__menu menu{
        padding: 20px;
        gap: 24px;
        flex-wrap: nowrap;
        height: calc(100vh - 300px);
        min-height: auto;
        height: calc(100dvh - 300px) ;
        overflow: auto;
        scrollbar-color: #174E72 #FFF;
        padding-right: 0;
        margin-right: 20px;
    }
    .main__menu menu li {
        gap:0px;
        width: 100%;
    }
    .main__menu menu li>a{
        height: 0px;
        overflow:hidden ;
        transition: .3s;
        font-weight: 500;
        color: #174E72;
    }
    .main__menu menu li.mini__cascader_active   > a{
        height: 20px;
        margin: 0 0 16px 24px;
    }
    .main__menu menu li.mini__cascader_active   > a{
        height: 20px;
        margin: 16px 0 0 24px;
    }
    .main__menu menu li.mini__cascader_active   > a:hover{
        color:#007BB8;
    }
    .main__menu menu h3{
        margin: 0;
        display: flex;
        justify-content: space-between;
        font-weight: 500;
      
    }
    .main__menu menu h3 a{ 
        color: #174E72;
    }
    .main__menu .main__menu__header_mini button{
        background-color: transparent;
        margin-right: 20px;
    }
    .main__menu  .main__menu__header_mini button::after, 
    .main__menu  .main__menu__header_mini button::before{
        background-color: #175472;
        width: 20px;
    }
    .main__menu  .last{
        display: none;
    }
    .main__menu  .main__menu__header_mini{
        display: flex;
        padding: 27px 0px 12px 20px;
        justify-content: space-between;
    }
    button.mini__cascader{
        background-color: transparent;  
        height: 20px;  
        display: block;
    }
    button.mini__cascader::after {
        position: absolute;
        right: 0;
        top: 17px;
        content: url(../../assets/corner.svg);
        transform: rotate(90deg);
        transform-origin: 15px 0px;
        transition: .3s;
        background-color: transparent;
    }

    .mini__cascader_active button.mini__cascader::after{
        transform: rotate(180deg);
        transform-origin: 7px 0px;
    }
    button.mini__cascader::before{
        display: none;
    }
    .main__menu .search-ms__button{
        display: block;
        box-sizing: border-box;
        border: solid 2px #175472;
        color: #0D3041;
        border-radius: 10px;
        background-color: var(--background);
        font-weight: 401;
        height: 100%;
        width: 100%;
        font-size: 14px;
        cursor: pointer;
        line-height: 130%;
        font-family: Rubik;
        font-variant: small-caps;
    }
    .main__menu .search-ms__button:hover {
        background-color: #EDF6FF;
    }
    .main__menu .search-ms__panel_button{
        margin-top: 24px;
        padding: 0 24px;
        width: 100%;
        box-sizing: border-box;
        height: 42px;
    }
    .main__menu menu a,
    .main__menu menu h3 a{
        font-size: 14px;
    }
}
</style>
